import { styled } from "@/components";

const StyledBox = styled("div")(({ theme }) => ({
  // position: "relative",
  // display: "flex",
  // height: "100vh",
  // position: "absolute",
  // bottom: theme.spacing(1),
  // right: theme.spacing(1),
  // position: "absolute",
  // right: theme.spacing(1),
  // left: theme.spacing(1),
  padding: theme.spacing(1),
  overflow: "hidden",
}));

const StyledContainer = styled("main")({
  // flexGrow: 1,
});

export { StyledBox, StyledContainer };
